import { env } from '@cc-shopping/platform-env';
import { configure, type ParamMap } from 'urlcat';

export const LEADING_TRAILING_SLASHES = /^\/+|\/+$/g;

const urlcat = configure({ objectFormat: { format: 'RFC3986' } });

export const buildUrl = (path: string, queryParams?: ParamMap) => {
  const baseUrl = env.NEXT_PUBLIC_NW_URL;
  const url = urlcat(baseUrl, path, queryParams);
  return url;
};

export function buildRelativePath(...segments: string[]): string {
  const stripped = segments.map(s => s.replace(LEADING_TRAILING_SLASHES, '')).filter(Boolean);
  return `/${stripped.join('/')}`;
}
